import { render } from "./calculatorSaveRemoveComponent.vue?vue&type=template&id=f10ff0e0"
import script from "./calculatorSaveRemoveComponent.vue?vue&type=script&lang=js"
export * from "./calculatorSaveRemoveComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__